"use strict";
var ApiQuoteResponse = (function () {
    function ApiQuoteResponse() {
    }
    return ApiQuoteResponse;
}());
exports.ApiQuoteResponse = ApiQuoteResponse;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-quote-response.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-quote-response.model.js